export default function initFloatingButtons() {
    const whatsappFab = document.querySelector('.cdr-whatsapp-fab');
    const whatsappMain = document.querySelector('.cdr-whatsapp-fab__main');
    const uberEatsFab = document.querySelector('.cdr-ubereats-fab');
    const uberEatsMain = document.querySelector('.cdr-ubereats-fab__main');

    const closeWhatsapp = () => {
        if (whatsappFab && whatsappFab.classList.contains('active')) {
            whatsappFab.classList.remove('active');
        }
    };

    const closeUberEats = () => {
        if (uberEatsFab && uberEatsFab.classList.contains('active')) {
            uberEatsFab.classList.remove('active');
        }
    };

    const closeAll = () => {
        closeWhatsapp();
        closeUberEats();
    };

    // WhatsApp FAB Toggle
    if (whatsappMain && whatsappFab) {
        whatsappMain.addEventListener('click', (e) => {
            e.stopPropagation();
            const isActive = whatsappFab.classList.contains('active');
            if (!isActive) {
                document.dispatchEvent(new CustomEvent('cdr:close-mobile-menu'));
                closeUberEats();
            }
            whatsappFab.classList.toggle('active');
        });
    }

    // Uber Eats FAB Toggle
    if (uberEatsMain && uberEatsFab) {
        uberEatsMain.addEventListener('click', (e) => {
            e.stopPropagation();
            const isActive = uberEatsFab.classList.contains('active');
            if (!isActive) {
                document.dispatchEvent(new CustomEvent('cdr:close-mobile-menu'));
                closeWhatsapp();
            }
            uberEatsFab.classList.toggle('active');
        });
    }

    // Listen for global close events
    document.addEventListener('cdr:close-floating-menus', closeAll);

    // Close on click outside
    document.addEventListener('click', (e) => {
        if (whatsappFab && !whatsappFab.contains(e.target)) {
            closeWhatsapp();
        }
        if (uberEatsFab && !uberEatsFab.contains(e.target)) {
            closeUberEats();
        }
    });
}
